import { MATCH_WORD_BETWEEN_ASTERISK } from 'common/src/app/data/regexPatterns';

const createScriptTitle = text =>
  text?.replace(MATCH_WORD_BETWEEN_ASTERISK, '<i class="script-title">$1</i>');

export default createScriptTitle;
